import api from './api/api';

export const saveLayoutToDatabase = async (layoutData, layoutType = 'personal', syncWithDefault = false) => {
    try {
        const response = await api.post('/api/layout/save', {
            ...layoutData,
            layoutType, // 'personal' or 'default'
            syncWithDefault // Only used for super admins
        });
        return response.data;
    } catch (error) {
        console.error('Error saving layout:', error);
        throw error;
    }
};

export const getLayoutFromDatabase = async (pageType, layoutType = 'personal') => {
    try {
        const response = await api.get(`/api/layout/get`, {
            params: { 
                pageType,
                layoutType // 'personal' or 'default'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching layout:', error);
        throw error;
    }
};

export const deleteLayoutFromDatabase = async (pageType, layoutType = 'personal') => {
    try {
        const response = await api.delete(`/api/layout/delete`, {
            params: { 
                pageType,
                layoutType // 'personal' or 'default'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error deleting layout:', error);
        throw error;
    }
};

export const getDefaultLayoutFromDatabase = async (pageType) => {
    try {
        const response = await api.get(`/api/layout/default`, {
            params: { pageType }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching default layout:', error);
        throw error;
    }
};

// New function to get layout based on user role and preference
export const getLayoutByType = async (pageType, layoutType = 'personal') => {
    try {
        const response = await api.get(`/api/layout/get-by-type`, {
            params: { 
                pageType,
                layoutType
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching layout by type:', error);
        throw error;
    }
};

// Toggle sync with default layout preference
export const toggleSyncPreference = async (pageType, syncWithDefault) => {
    try {
        const response = await api.post('/api/layout/toggle-sync-preference', {
            pageType,
            syncWithDefault
        });
        return response.data;
    } catch (error) {
        console.error('Error toggling sync preference:', error);
        throw error;
    }
};

// Get sync preference status
export const getSyncPreference = async (pageType) => {
    try {
        const response = await api.get('/api/layout/sync-preference', {
            params: { pageType }
        });        
        return response.data; // Return response.data instead of response
    } catch (error) {
        console.error('Error fetching sync preference:', error);
        throw error;
    }
};

// Set personal layout same as default layout
export const setPersonalLayoutSameAsDefault = async (pageType) => {
    try {
        const response = await api.post('/api/layout/set-same-as-default', {
            pageType
        });
        return response.data;
    } catch (error) {
        console.error('Error setting personal layout same as default:', error);
        throw error;
    }
}; 

// Check if layout was recently auto-synced (for notifications)
export const checkAutoSync = async (pageType) => {
    try {
        const response = await api.get('/api/layout/check-auto-sync', {
            params: { pageType }
        });
        return response.data;
    } catch (error) {
        console.error('Error checking auto-sync status:', error);
        throw error;
    }
}; 